class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      return user.refresh_token;
    }
    return null
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      return user.access_token;
    }
    return null
  }

  removeLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      delete user.access_token
      localStorage.setItem("user", JSON.stringify(user));
    }
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("user"));
    user.accessToken = token;
    localStorage.setItem("user", JSON.stringify(user));
  }

  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  }


  removeUser() {
    localStorage.removeItem("user");
  }
}

export default new TokenService();



// WEBPACK FOOTER //
// ./src/services/tokenService.js